import React from 'react';

export default function InputContainer(props) {
  let inputProps = {
    className: `input-field ${props.inputClass || ''}`,
    type: props.type || 'text',
    value: props.value,
    placeholder: props.placeholder || '',
    onChange: props.handleChange,
    disabled: props.disabled,
    name: props.name,
  };

  if (props.rest) {
    inputProps = {
      ...inputProps,
      ...props.rest,
    };
  }

  if (props.validate) {
    inputProps.onBlur = (event) => {
      props.validate(event.target.value);
    };
  }

  return (
    <div
      className={`${
        props.validationError ? 'input-container invalid' : 'input-container'
      } ${props.className || ''}`}
    >
      <input {...inputProps} />
      {props.validationError && (
        <p className="input-validation-error mt-1">{props.validationError}</p>
      )}
    </div>
  );
}
